// De zeven LevelLeven kernbegrippen.
// Kleuren zijn methodiek-taal:
//   Startpunt → sky (lichtblauw · ruimte)
//   Rugzak    → oker (dragen)
//   Rem       → coral (aandacht)
//   Vonk      → geel (energie)
//   Speelruimte → moss (oefenen · beweging)
//   LevelMoment → navy (verdieping · verankering)
//   Volgende beweging → coral (eerste stap · aandacht)
// Elk begrip heeft drie lagen: voorJou · voorProfessional · onderMotorkap.

export const METHODIEK = [
  {
    n: "01",
    naam: "Startpunt",
    kleur: "#97B79D",
    kernvraag: "Waar sta je eigenlijk?",
    doel: "Zonder oordeel vastleggen waar iemand vertrekt. Nulmeting, maar dan in taal die past.",
    activiteit: "Kennismaking, biografische kaart, dagritme-scan, wat leeft er op dit moment.",
    observatie: "Hoe iemand binnenkomt: eerste gesprek, hoe wordt de vraag beantwoord, wat blijft ongezegd.",
    meetpunt: "Zelfrapportage T=0 · vragenlijst welbevinden, ervaren perspectief, dagstructuur.",
    voorJou: "Hier begint het. Geen test, geen plan. Alleen: waar sta je nu? Wat ging er vandaag goed? Wat sleept? Er hoeft nog niets vast te staan.",
    voorProfessional: "Kennismaking in kleine setting. Biografische kaart en dagritme-scan. Doel: veiligheid en context, geen inhoudelijke agenda.",
    onderMotorkap: "Gestoeld op fenomenologische intake (Van Manen) en 'unconditional positive regard' (Rogers). Nulmeting via ISK-korte vragenlijst.",
  },
  {
    n: "02",
    naam: "Rugzak",
    kleur: "#D4A94A",
    kernvraag: "Wat neem je allemaal mee?",
    doel: "Zichtbaar maken wat iemand aan geschiedenis, patronen en overtuigingen bij zich heeft.",
    activiteit: "Biografisch werken, systemisch werken, opstellingen in kleine groep.",
    observatie: "Terugkerende patronen, verhalen die zich herhalen, wat wél en niet mag.",
    meetpunt: "Zelfinzicht-score, aantal geformuleerde patronen, herkende overtuigingen.",
    voorJou: "Iedereen draagt iets mee. Verhalen, gewoontes, dingen die je hebt geleerd of nooit hebt kunnen afleren. We gaan kijken wat daarvan echt van jou is.",
    voorProfessional: "Biografisch en systemisch werken. Doel: patroon van thema-herhaling zichtbaar maken zonder therapeutiseren.",
    onderMotorkap: "Systemisch werk (Hellinger), narratieve therapie (White & Epston). Wordt gebruikt als exploratie, niet als behandeling.",
  },
  {
    n: "03",
    naam: "Rem",
    kleur: "#E06B3F",
    kernvraag: "Wat houdt beweging tegen?",
    doel: "Benoemen wat werkelijk verhindert dat de volgende stap gezet wordt.",
    activiteit: "Belemmerende overtuigingen expliciet maken, systeem in kaart brengen, taal geven aan wat vastzet.",
    observatie: "Waar iemand terugvalt, waar de energie zakt, welke situaties gemeden worden.",
    meetpunt: "Genoemde belemmeringen, mate van eigenaarschap, verschuiving in zelfbeeld.",
    voorJou: "Harder duwen helpt niet als je niet weet wat er remt. We kijken samen: wat gaat áán als er beweging gevraagd wordt? En van wie is die stem eigenlijk?",
    voorProfessional: "Werkvorm 'stem in het hoofd', gecombineerd met MI-explorerende vragen. Onderscheid maken tussen extrinsieke druk en intrinsieke twijfel.",
    onderMotorkap: "Motivational Interviewing (Miller & Rollnick), Transactionele Analyse (ouder-kind-volwassen).",
  },
  {
    n: "04",
    naam: "Vonk",
    kleur: "#F0B98D",
    kernvraag: "Waar komt weer een beetje energie?",
    doel: "Zoeken naar het moment dat iets oplicht — motivatie is geen bron, het is een reactie.",
    activiteit: "Doen wat je vroeger leuk vond, uitproberen, maken, bewegen, ontdekken zonder doel.",
    observatie: "Waar de blik verandert, waar iemand ineens langer blijft, waar iets écht raakt.",
    meetpunt: "Aantal geregistreerde vonken · zelfgekozen activiteiten die gecontinueerd worden.",
    voorJou: "Motivatie komt niet uit een gesprek. Ze komt uit iets doen. Fietsen, koken, muziek maken, iets bouwen. We proberen tot iets even oplicht.",
    voorProfessional: "Ervaringsgericht werken: 80% oefening, 20% reflectie. Vonken worden benoemd, geregistreerd en herhaald.",
    onderMotorkap: "Zelfdeterminatietheorie (Ryan & Deci, 2000): intrinsieke motivatie ontstaat bij autonomie, competentie en verbondenheid.",
  },
  {
    n: "05",
    naam: "Speelruimte",
    kleur: "#78A85A",
    kernvraag: "Wat kun je proberen zonder dat het meteen hoeft te lukken?",
    doel: "Ruimte scheppen om iets nieuws te doen zonder dat het meteen moet werken of goed moet zijn.",
    activiteit: "Kleine experimenten, meelopen bij partners, korte werk-proeverijen, participatie in de wijk.",
    observatie: "Hoe iemand omgaat met falen, met feedback, met een nieuw ritme.",
    meetpunt: "Aantal experimenten · frequentie van deelname · zelfgerapporteerde speelruimte-score.",
    voorJou: "Je hoeft het niet meteen goed te doen. Meelopen, iets proberen, opnieuw beginnen — dat mag hier. Zonder consequenties. Zo krijg je vanzelf richting.",
    voorProfessional: "Micro-experimenten in echte context (wijk, werkplek, opleiding). Reflectie in kleine groep na elke ronde.",
    onderMotorkap: "Kolb's leercyclus (concrete ervaring → reflectie → conceptualisering → experimenteren). Combineert met veilige groepscultuur (Edmondson).",
  },
  {
    n: "06",
    naam: "LevelMoment",
    kleur: "#1F5132",
    kernvraag: "Wat lukt vandaag dat eerder nog niet lukte?",
    doel: "Het moment vangen dat iemand voelt: nu ben ik iets anders geworden. Vaak zonder woorden.",
    activiteit: "Rituelen, groepsbeleving, terugblik, feedback vanuit de groep, klein certificaat per moment.",
    observatie: "Getuigenis van medegedeelnemers, veranderende taal, andere lichaamshouding.",
    meetpunt: "Kwalitatieve momenten in dossier · groepsobservaties · shift in zelfrapportage.",
    voorJou: "Soms verandert er iets zonder dat je het meteen merkt. Iemand anders ziet het wél. Deze momenten leggen we vast — voor later, als het weer moeilijker wordt.",
    voorProfessional: "Erkenningsritueel in kleine groep, opgenomen in dossier. Werkt als anker bij terugval en als bewijs bij warme overdracht.",
    onderMotorkap: "Ritual studies (Turner) + narratief geheugen: erkenning door de groep verankert identiteitsverschuiving sterker dan zelfrapportage alleen.",
  },
  {
    n: "07",
    naam: "Volgende beweging",
    kleur: "#E06B3F",
    kernvraag: "Wat past nu?",
    doel: "Van innerlijke verandering naar concrete, haalbare vervolgstap in de buitenwereld.",
    activiteit: "Vervolgroute-gesprek, warme overdracht aan re-integratie, opleiding, participatie of werkgever.",
    observatie: "Verankering van de stap: houdt het stand, wordt de route gedragen door omgeving.",
    meetpunt: "Uitstroomstatus T=12 en T=18 · duurzaamheid van de gekozen vervolgstap.",
    voorJou: "Geen sprong, wel een stap. Werk, opleiding, vrijwilligerswerk, of eerst nog wat oefenen. We kiezen wat past bij waar je nu écht bent — met de mensen erbij die het waarmaken.",
    voorProfessional: "Vervolgroute-gesprek met deelnemer, gemeente en ontvangende partij. Warme overdracht, met LevelMoment-dossier als context.",
    onderMotorkap: "Transtheoretisch model van gedragsverandering (Prochaska & DiClemente): de vervolgstap moet passen bij de huidige fase (contemplatie → actie → volhouden).",
  },
];
